'use strict';

module.exports = require('./lib/React');



/*****************
 ** WEBPACK FOOTER
 ** ./~/react/react.js
 ** module id = 6
 ** module chunks = 1
 **/